<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.contracts.unsuspend_confirm_title')"
        :message="__('customers.contracts.unsuspend_confirm_message')"
        is-confirm
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        is-error
        @update:show="$emit('update:showModal', $event)"
        @confirm="unsuspendContractConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'UnsuspendContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: ''
        }
    },
    methods: {
        unsuspendContractConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.unsuspend-contract', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.redirectTo,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        }
    }
}
</script>
